/**
 * Invite flow: legacy GET /auth/signup_request/:id must match the email used on the signup form.
 */

export function normalizeEmailForCompare(value) {
  return typeof value === "string" ? value.trim().toLowerCase() : "";
}

/**
 * @param {import("axios").AxiosResponse} res
 * @returns {string}
 */
export function emailFromSignupRequestResponse(res) {
  const body = res?.data;
  if (!body || typeof body !== "object") return "";
  const nested = body.data;
  if (nested && typeof nested === "object" && typeof nested.email === "string") {
    return nested.email;
  }
  if (typeof body.email === "string") return body.email;
  return "";
}
